import type { Release } from '../releases.ts';

export default {
  version: '0.13.0',
  date: '2026-10-02',
  title: 'Viewing and export',
  summary: [
    'Programme in and out timecodes in the metadata, marked on the player',
    'Export the whole asset, its programme or a marked range',
    'Broadcast export formats: AVC-Intra, XDCAM HD422, ProRes and DNxHR',
    'A strip of thumbnails above the waveform',
    'Choose and order the Library’s list columns',
  ],
  features: [
    'Programme in and out timecodes in the metadata model, marked on the player’s timeline and settable from the marked in and out',
    'Export from the asset page: the whole asset, its programme, or a marked range',
    'Broadcast export formats: AVC-Intra 100 1080i MXF, XDCAM HD422 1080i MXF, ProRes 422 HQ 1080i and 1080p, DNxHR HQ MXF',
    'A strip of thumbnails above the player’s waveform',
    'Choose and order the library’s list columns; saved for each person',
  ],
  fixes: [],
} satisfies Release;
